import {Outlet} from 'react-router'
import {Header} from '~/features/Header/Header'
import {Footer} from './Footer'
import {useRootLoaderData} from '~/utils/useRootLoaderData'

export default function StandardLayout() {
  const {shouldDisplayFooter} = useRootLoaderData()

  return (
    <>
      <Header />
      <Outlet />
      {shouldDisplayFooter && <Footer />}
    </>
  )
}
